import { render, staticRenderFns } from "./KoTermsOfUse.vue?vue&type=template&id=b0fb341e&scoped=true"
import script from "./KoTermsOfUse.vue?vue&type=script&lang=js"
export * from "./KoTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b0fb341e",
  null
  ,true
)

export default component.exports